import { getLocale } from "../runtime";

const sv_iconwarning = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Varning`
};

const iconwarning = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_iconwarning(inputs)
	return "iconWarning";
};

export { iconwarning as "iconWarning" };